import { PatientSignupEntryPoint } from "@shared/hooks/useAnalyticsLogger/PatientAnalyticsEntryPoint";
import { useSearchParams } from "@shared/react-router-dom/react-router-dom";

const CARE_CONTINUITY_ENTRY_POINTS: string[] = [
  PatientSignupEntryPoint.ORPHANED_ACCOUNT_LOGIN,
  PatientSignupEntryPoint.NO_INVITE_SIGNUP,
];

/**
 * True when the visitor arrived on the signup page through a Care Continuity
 * redirect, identified by the `entry_point` funnel param the deflection and
 * no-invite email links carry. Single source of truth for the banner and the
 * "Create your account" heading, so the two can't drift.
 */
const useCareContinuityRedirect = (): boolean => {
  const [searchParameters] = useSearchParams();
  const entryPoint = searchParameters.get("entry_point");

  return entryPoint !== null && CARE_CONTINUITY_ENTRY_POINTS.includes(entryPoint);
};

export { useCareContinuityRedirect };
